import logomark from '../../assets/logomark.svg';

// Page frame for the customer-facing portals (/sign, /pay). Matches the Ops
// passport verify page: warm neutral base, tiled logomark, AGRIWARE wordmark.
// `tone` tints the base the way verify does: green for done, red for a dead end.
export const PORTAL = {
  text: '#2C2C2A',
  secondary: '#5F5E5A',
  tertiary: '#888780',
  bg: '#F1EFE8',
  border: '#D3D1C7',
  hair: '#E8E6DE',
  slate: '#374550',
  orange: '#FF6600', // logo orange, also the Stripe brand colour
};

const TONES = { neutral: PORTAL.bg, success: '#EEF5EC', danger: '#FBEFEF' };

export default function PortalShell({ children, maxWidth = 680, tone = 'neutral', footer }) {
  return (
    <div style={{
      position: 'relative',
      minHeight: '100vh',
      background: TONES[tone] || PORTAL.bg,
      transition: 'background 0.5s ease',
      padding: '28px 16px 56px',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }}>
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: '-40%',
          backgroundImage: `url(${logomark})`,
          backgroundRepeat: 'repeat',
          backgroundSize: '92px auto',
          transform: 'rotate(-45deg)',
          transformOrigin: 'center',
          // Greyscale + multiply so the marks take on the tone underneath.
          filter: 'grayscale(1)',
          opacity: 0.14,
          mixBlendMode: 'multiply',
          pointerEvents: 'none',
        }}
      />
      <div style={{ position: 'relative', maxWidth, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
          <img src={logomark} alt="" style={{ height: 28, width: 28 }} />
          <div style={{ fontSize: 15, color: PORTAL.slate, letterSpacing: 0.4 }}>
            <strong style={{ fontWeight: 600 }}>AGRI</strong>WARE
          </div>
        </div>
        {children}
        <div style={{ marginTop: 24, fontSize: 11, color: PORTAL.tertiary, textAlign: 'center', lineHeight: 1.6 }}>
          {footer || 'Agriware Ltd'}
        </div>
      </div>
    </div>
  );
}

export function PortalPanel({ children, style }) {
  return (
    <div style={{
      background: '#fff', border: `0.5px solid ${PORTAL.border}`, borderRadius: 8,
      padding: '20px 22px', ...style,
    }}>{children}</div>
  );
}
